module.exports = __webpack_public_path__ + "static/media/sex Addiction.32aa74c2.svg";